export var DISTRIBUTORS_LIST_PATH = '/distributors/';
export var DISTRIBUTOR_CREATE_PATH = '/distributors/create';
